import { ReactSVG } from 'react-svg';
import { clsx } from 'clsx';

interface SiloOptionProps {
  type: string;
  currentType: string;
  handleInputChange: (name: any, value: any) => void;
  label: string;
  icon: string;
}

const SiloOption: React.FC<SiloOptionProps> = ({
  type,
  currentType,
  handleInputChange,
  label,
  icon,
}) => (
  <div
    className="flex items-center gap-2-0 cursor-pointer"
    onClick={() => handleInputChange('icon', type)}
  >
    <div>
      <div
        className={clsx(
          currentType === type && 'bg-primary-green',
          'rounded-full w-2-0 h-2-0 border-primary-grey border-[3px]',
        )}
      ></div>
    </div>
    <div className="flex items-center">
      <ReactSVG
        src={icon}
        className="w-4-0 h-4-0"
        beforeInjection={(svg) => {
          svg.setAttribute('style', 'height: 3.2rem; width:auto');
        }}
      />
      <span className="text-1-4">{label}</span>
    </div>
  </div>
);

export default SiloOption;
